{% block sw_cms_element_acris_blog_author_date %}
    <div class="sw-cms-el-acris-blog-author-date">
        <div v-if="element.config.layout.value == 'author_text'">
            {{ $tc('acris-blog.elements.blogAuthorDate.preview.authorText') }}
        </div>
        <div v-else-if="element.config.layout.value == 'only_author'">
            {{ $tc('acris-blog.elements.blogAuthorDate.preview.onlyAuthor') }}
        </div>
        <div v-else-if="element.config.layout.value == 'date_text'">
            {{ $tc('acris-blog.elements.blogAuthorDate.preview.dateText') }}
        </div>
        <div v-else-if="element.config.layout.value == 'only_date'">
            {{ $tc('acris-blog.elements.blogAuthorDate.preview.onlyDate') }}
        </div>
        <div v-else>
            {{ $tc('acris-blog.elements.blogAuthorDate.preview.content') }}
        </div>
    </div>
{% endblock %}
